import React from 'react';
import { useResponsive } from '@parsina/framework';
import PatientsWeb from './Patients.web.jsx';
import PatientsMobile from './Patients.mobile.jsx';

// بیماران — two surfaces, one register.
//
// The desktop is a four-column kit `Table` with a `Pager`; the phone is a list
// of tappable cards that grows through «نمایش بیشتر» (§4 — never infinite
// scroll, and never a row of 34px pager buttons on a touch screen).
//
// Both read the same `usePatients` at the same `DEFAULT_PAGE_SIZE`, apply the
// same `searchTerm`/`MIN_SEARCH_LENGTH` and honour the same `?q=`/`?page=` URL
// contract — so a link opened on either device shows the same patients.
const PatientsScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <PatientsMobile /> : <PatientsWeb />;
};

export default PatientsScreen;
